import { render, staticRenderFns } from "./whatIsItForCard.vue?vue&type=template&id=4e4eb8d4&scoped=true"
import script from "./whatIsItForCard.vue?vue&type=script&lang=js"
export * from "./whatIsItForCard.vue?vue&type=script&lang=js"
import style0 from "./whatIsItForCard.vue?vue&type=style&index=0&id=4e4eb8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4eb8d4",
  null
  
)

export default component.exports